// currencyActions.js

export const setCurrency = (currency) => ({
    type: 'SET_CURRENCY',
    payload: currency,
});
